import { http, HttpResponse } from 'msw'

interface MockActivateDistributionPathParams {
  alphaId: string
  distributionAlphaId: string
}

export const mockActivateDistribution =
  http.put<MockActivateDistributionPathParams>(
    '/my-business/api/agency/v1/*/:alphaId/distributions/:distributionAlphaId/activated',
    () => {
      return HttpResponse.json(null, { status: 200 })
    },
  )
